export default {
  registerInvoiceData: [],
  dataForUpdatePartner: {}
};
